import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss'],
})
export class SblockCourseListComponent {
  title = 'Nuestros Cursos Destacados';
  subtitle = 'Aprende a tu ritmo con contenido elaborado por especialistas';

  courses = [
    {
      id: 1,
      name: 'Introducción a la Espiritualidad',
      image: 'https://picsum.photos/seed/curso1/600/400',
      count: 8,
      price: 49,
      discounted: true,
      discountRate: 20,
      finalPrice: 39,
      free: false,
    },
    {
      id: 2,
      name: 'Formación en Catequesis',
      image: 'https://picsum.photos/seed/curso2/600/400',
      count: 1,
      price: 35,
      discounted: false,
      discountRate: 0,
      finalPrice: 35,
      free: false,
    },
    {
      id: 3,
      name: 'Historia de la Iglesia',
      image: 'https://picsum.photos/seed/curso3/600/400',
      count: 12,
      price: 0,
      discounted: false,
      discountRate: 0,
      finalPrice: 0,
      free: true,
    },
    {
      id: 4,
      name: 'Liturgia y Sacramentos',
      image: 'https://picsum.photos/seed/curso4/600/400',
      count: 6,
      price: 59,
      discounted: true,
      discountRate: 15,
      finalPrice: 50,
      free: false,
    },
    {
      id: 5,
      name: 'Acompañamiento Pastoral',
      image: 'https://picsum.photos/seed/curso5/600/400',
      count: 10,
      price: 45,
      discounted: false,
      discountRate: 0,
      finalPrice: 45,
      free: false,
    },
    {
      id: 6,
      name: 'Oración y Contemplación',
      image: 'https://picsum.photos/seed/curso6/600/400',
      count: 4,
      price: 0,
      discounted: false,
      discountRate: 0,
      finalPrice: 0,
      free: true,
    },
  ];
}
